import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  Input,
  Dropdown,
  Button,
  Popup,
  Label,
  Grid,
  Container
} from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import modes from './constants/modes';
import errors from './constants/errors';

import AssetTagSelection from './AssetTagSelection';
import { getTagsForCategories } from './../../../../src/services/TagService';
import {
  makePut,
  makeGetWithParam
} from './../../../../src/services/ServiceManager';

class AssetGalleryNav extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filenameSearchTimeoutId: null,
      searching: false,
      editing: false,
      deleting: false,
      openEditPopup: false,
      tagOptions: {},
      selectedTagOptions: {},
      searchParams: {}, // This is only for filename, oem and asset type input fields..
      error: {
        type: null,
        message: ''
      },
      searchTagPlaceholders: {}
    };
  }

  categories = ['oem', 'year', 'product', 'type'];

  componentDidMount() {
    this.getPlaceholderFromSession();
  }

  componentWillReceiveProps(nextProps) {
    const { mode: prevMode } = this.props;
    const { mode } = nextProps;

    if (prevMode !== mode && mode !== modes.ASSET_GALLERY.EDITTING) {
      this.setState((prevState) => ({
        ...prevState,
        editing: false
      }));
    }
  }

  onFilterPanelOpen = () => {
    const { toggleFilterPanel, isFilterPanelOpened } = this.props;

    let updatedPanelState = isFilterPanelOpened;
    if (updatedPanelState) {
      updatedPanelState = !isFilterPanelOpened;
    } else {
      updatedPanelState = true;
    }

    if (toggleFilterPanel) toggleFilterPanel(updatedPanelState);
  };

  onUploaderPanelOpen = () => {
    const { toggleUploaderPanel, isUploaderPanelOpened } = this.props;

    let updatedPanelState = isUploaderPanelOpened;
    if (updatedPanelState) {
      updatedPanelState = !isUploaderPanelOpened;
    } else {
      updatedPanelState = true;
    }

    if (toggleUploaderPanel) toggleUploaderPanel(updatedPanelState);
  };

  onDeselectButtonClick = () => {
    const { updateSelectedAssets } = this.props;

    if (updateSelectedAssets) updateSelectedAssets([]);
  };

  onEditButtonClick = () => {
    this.setState(
      {
        ...this.state,
        editing: true
      },
      () => {
        const { updateGalleryMode } = this.props;

        if (updateGalleryMode) updateGalleryMode('EDITTING');
      }
    );
  };

  onEditCancelButtonClick = () => {
    this.setState(
      {
        ...this.state,
        editing: false
      },
      () => {
        const { updateGalleryMode } = this.props;

        if (updateGalleryMode) updateGalleryMode('NORMAL');
      }
    );
  };

  onDeleteButtonClick = (event) => {
    event.preventDefault();

    this.setState(
      {
        ...this.state,
        deleting: true,
        error: {
          type: null,
          message: ''
        }
      },
      () => {
        const { deleteSelectedAssets } = this.props;

        if (deleteSelectedAssets) {
          deleteSelectedAssets((error) => {
            this.setState((prevState) => ({
              ...prevState,
              deleting: false,
              error: error || { type: null, message: '' }
            }));
          });
        }
      }
    );
  };

  onEditPopupButtonClick = (event) => {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      openEditPopup: true
    }));
  };

  onEditPopupClose = (event) => {
    event.preventDefault();

    this.setState((prevState) => ({
      ...prevState,
      openEditPopup: false
    }));
  };

  onSearchFilenameChange = (event, { value }) => {
    const { filenameSearchTimeoutId } = this.state;

    this.setState((prevState) => ({
      ...prevState,
      searching: true
    }));

    clearTimeout(filenameSearchTimeoutId);

    const tmpTimeoutId = setTimeout(() => {
      this.setState(
        {
          ...this.state,
          searching: true
        },
        () => {
          const { searchAssets } = this.props;

          if (searchAssets) {
            searchAssets('filename', value, () => {
              this.setState((prevState) => ({
                ...prevState,
                searching: false
              }));
            });
          }
        }
      );
    }, 1000);

    this.setState((prevState) => ({
      ...prevState,
      filenameSearchTimeoutId: tmpTimeoutId,
      searchParams: {
        ...prevState.searchParams,
        filename: value
      }
    }));
  };

  onClearFilterButtonClick = (event) => {
    event.preventDefault();

    this.setState(
      {
        ...this.state,
        searchParams: {}
      },
      () => {
        const { clearSearch } = this.props;

        if (clearSearch) clearSearch();
      }
    );
  };

  onDropdownClick = (event, { category }) => {
    // check if the selection category for the dropdown already loaded data.
    const { tagOptions, user } = this.props;
    const { groups, email } = user;
    const applyGuestFilter = ['NU'].includes(groups[0]);

    if (!category || !tagOptions) return;

    const categories = Object.keys(tagOptions);

    const isTagOptionsLoaded = categories.indexOf(category) > -1;

    if (!isTagOptionsLoaded) {
      this.setState(
        {
          ...this.state,
          loadingCategory: category
        },
        () => {
          // TODO: check when editing the url in the function. On server the request may fail.
          makeGetWithParam(
            `service/tags/category/${category}`,
            null,
            `${
              applyGuestFilter ? `?created_by=${encodeURIComponent(email)}` : ''
            }`
          ).then((result) => {
            const { tags } = result;

            const selected = tags.map((tag) => {
              const { id, value } = tag;
              return {
                key: id,
                text: value,
                value: id,
                category
              };
            });

            const { updateTagOptions } = this.props;

            updateTagOptions(
              {
                [category]: selected
              },
              // this callback will be called when the tags selected are set for this category in AssetGallery.jsx
              () => {
                this.setState((prevState) => ({
                  ...prevState,
                  loadingCategory: null
                }));
              }
            );
          });
        }
      );
    }
  };

  // TODO: handle exception cases
  onDropdownChange = (event, { value, category }) => {
    this.setState(
      {
        ...this.state,
        searchParams: {
          ...this.state.searchParams,
          [category]: value
        },
        searchTagPlaceholders: {}
      },
      () => {
        // need [{ [category]: [tag.value]}]
        // value is the list of tag id
        const valueList = value.map((tmpValue) => {
          const { tagOptions } = this.props;

          const tagOption = tagOptions[category]
            ? tagOptions[category].find((option) => option.key === tmpValue)
            : null;

          if (!tagOption) throw new Error('Tag option cannot be found.');

          return tagOption.text;
        });

        const { searchAssets } = this.props;

        if (searchAssets) searchAssets(category, valueList);

        this.saveSearchSession();
      }
    );
  };

  resetSelectTagOptions = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedTagOptions: {}
    }));
  };

  /**
   * @param {string} category
   * @param {number[]} optionKeys The tags ids that are selected from the dropdowns.
   *
   * NOTE
   *
   * the optionsKeys is the full set of selected tag ids.
   *
   * This function will be duplicated in AssetGalleryNav.jsx
   */
  updateSelectedTagOptions = (category, optionKeys) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedTagOptions: {
        ...prevState.selectedTagOptions,
        [category]: optionKeys
      }
    }));
  };

  updateAssetTags = (callback) => {
    const { selectedTagOptions } = this.state;
    const { selectedAssets } = this.props;

    if (!selectedTagOptions || Object.keys(selectedTagOptions).length === 0) {
      callback({
        type: errors.ASSET_TAG_SELECTION.NO_TAG_SELECTED,
        message: 'No tags are selected. Please select at least one tag.'
      });

      return;
    }

    const assetIds = selectedAssets.map((selectedAsset) => selectedAsset.id);

    const tagIds = Object.keys(selectedTagOptions)
      .map((key) => {
        const options = selectedTagOptions[key];

        return options;
      })
      .flat()
      .map((option) => option.key);

    Promise.all(
      assetIds.map((assetId) =>
        makePut(
          'service/tags',
          {
            assetId,
            tagIds
          },
          null
        )
      )
    ).then((results) => {
      const isFailed =
        results.filter((result) => result.statusCode !== 200).length > 0;

      if (isFailed) {
        callback({
          type: errors.ASSET_TAG_SELECTION.TAG_UPDATE_FAILED,
          message: 'There was an error. Please try again.'
        });
      } else {
        // updated tags are all same. Take the first one.
        const firstResult = results[0]; // results should not be empty based on the current logic.
        const { tags } = firstResult;

        this.setState(
          {
            ...this.state,
            openEditPopup: false,
            selectedTagOptions: {}
          },
          () => {
            const { updateAssetTags: updateAssetTagsInProps } = this.props; // the function name can be better...

            if (updateAssetTagsInProps) updateAssetTagsInProps(assetIds, tags);
          }
        );
      }
    });
  };

  saveSearchSession = () => {
    const { searchParams } = this.state;
    window.sessionStorage.setItem('searchParams', JSON.stringify(searchParams));
  };

  loadSearchSession = () => {
    const searchParams = window.sessionStorage.getItem('searchParams');
    if (searchParams) {
      return JSON.parse(searchParams);
    }
    return {};
  };

  getPlaceholderFromSession = async () => {
    const searchParams = this.loadSearchSession();
    const categories = ['oem', 'year', 'product', 'type'];
    const foundPlaceHolders = {};
    if (searchParams) {
      const { groups, email } = this.props.user;
      const applyGuestFilter = ['NU'].includes(groups[0]);

      const tagsForCategoriesData = await getTagsForCategories(
        categories,
        applyGuestFilter ? email : null
      );
      const tagsForCategories = tagsForCategoriesData
        ? tagsForCategoriesData.results
        : {};
      if (tagsForCategories) {
        tagsForCategories.forEach((catGroup) => {
          const category = catGroup.category;
          if (searchParams[category] && searchParams[category].length >= 0) {
            foundPlaceHolders[category] = [];
            searchParams[category].forEach((tagId) => {
              const foundTags = catGroup.tags.filter((tag) => {
                return tagId === tag.id;
              });
              if (foundTags.length > 0) {
                foundTags.forEach((foundTag) => {
                  foundPlaceHolders[category].push(foundTag.value);
                });
              }
            });
          }
        });
        if (foundPlaceHolders) {
          this.setState({ searchTagPlaceholders: foundPlaceHolders });
        }
      }
    }
  };

  setSearchParamsFromSession = async () => {
    const searchParams = this.loadSearchSession();
    const { searchTagPlaceholders } = this.state;
    toast.info('Last searched tags were applied!', {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    const { searchAssets } = this.props;

    await Promise.all(
      this.categories.map(async (category) => {
        if (searchTagPlaceholders[category]) {
          if (
            searchTagPlaceholders[category] !== [] &&
            searchTagPlaceholders[category].length >= 1
          ) {
            if (searchAssets) {
              await this.searchAssets(
                category,
                searchTagPlaceholders[category]
              );
            }
          }
        }
      })
    );

    this.setState((prevState) => ({
      ...prevState,
      searchParams
    }));
  };

  searchAssets = async (category, categoryTags) => {
    try {
      const { groups, email } = this.props.user;
      const applyGuestFilter = ['NU'].includes(groups[0]);

      const result = await makeGetWithParam(
        `service/tags/category/${category}`,
        null,
        `${applyGuestFilter ? `?created_by=${encodeURIComponent(email)}` : ''}`
      );

      const { tags } = result;
      const selected = tags.map((tag) => {
        const { id, value } = tag;
        return {
          key: id,
          text: value,
          value: id,
          category
        };
      });

      const { updateTagOptions } = this.props;

      updateTagOptions(
        {
          [category]: selected
        },
        () => {
          const { searchAssets } = this.props;
          searchAssets(category, categoryTags, () => {
            this.forceUpdate();
          });
        }
      );
    } catch (error) {
      console.log('Error in searchAssets: ', error);
    }
  };

  render() {
    const {
      searching,
      editing,
      deleting,
      openEditPopup,
      error,
      selectedTagOptions,
      searchParams,
      searchTagPlaceholders
    } = this.state;
    const {
      selectedAssets,
      tagOptions,
      updateTagOptions,
      mode,
      processedFiles,
      didAssetSelected,
      user
    } = this.props;

    const numberOfFilesInWorker = processedFiles.filter(
      (file) => file.workerInProgress
    ).length;

    const oemTagOptions = tagOptions.oem ? tagOptions.oem : [];
    const typeOptions = tagOptions.type ? tagOptions.type : [];
    const yearOptions = tagOptions.year ? tagOptions.year : [];
    const productOptions = tagOptions.product ? tagOptions.product : [];

    const disableSearchingField =
      mode === modes.ASSET_GALLERY.SEARCHING ||
      mode === modes.ASSET_GALLERY.UPLOAD_PENDING ||
      mode === modes.ASSET_GALLERY.UPLOADING;
    return (
      <div>
        <Container fluid>
          <Grid columns="equal" padded>
            <Popup
              trigger={
                <Label
                  as="a"
                  corner="left"
                  icon="magic"
                  onClick={() => this.setSearchParamsFromSession()}
                  hideOnScroll
                />
              }
              on="hover"
              content="Click this button to fill the tag dropdowns with your previous search"
            />
            <ToastContainer />
            <Grid.Row>
              <Grid.Column>
                <Input
                  icon="search"
                  placeholder="File name"
                  onChange={this.onSearchFilenameChange}
                  disabled={disableSearchingField}
                  loading={searching}
                  value={searchParams.filename ? searchParams.filename : ''}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  key="oem"
                  category="oem"
                  placeholder={
                    searchTagPlaceholders.oem &&
                    searchTagPlaceholders.oem.length >= 1
                      ? searchTagPlaceholders.oem.join()
                      : 'OEM'
                  }
                  multiple
                  search
                  selection
                  options={oemTagOptions}
                  onClick={this.onDropdownClick}
                  onChange={this.onDropdownChange}
                  disabled={disableSearchingField}
                  style={{ marginLeft: '1em' }}
                  value={searchParams.oem ? searchParams.oem : []}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  key="year"
                  category="year"
                  placeholder={
                    searchTagPlaceholders.year &&
                    searchTagPlaceholders.year.length >= 1
                      ? searchTagPlaceholders.year.join()
                      : 'Year'
                  }
                  multiple
                  search
                  selection
                  options={yearOptions}
                  onClick={this.onDropdownClick}
                  onChange={this.onDropdownChange}
                  disabled={disableSearchingField}
                  style={{ marginLeft: '1em' }}
                  value={searchParams.year ? searchParams.year : []}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  key="product"
                  category="product"
                  placeholder={
                    searchTagPlaceholders.product &&
                    searchTagPlaceholders.product.length >= 1
                      ? searchTagPlaceholders.product.join()
                      : 'Product'
                  }
                  multiple
                  search
                  selection
                  options={productOptions}
                  onClick={this.onDropdownClick}
                  onChange={this.onDropdownChange}
                  disabled={disableSearchingField}
                  style={{ marginLeft: '1em' }}
                  value={searchParams.product ? searchParams.product : []}
                />
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  key="type"
                  category="type"
                  placeholder={
                    searchTagPlaceholders.type &&
                    searchTagPlaceholders.type.length >= 1
                      ? searchTagPlaceholders.type.join()
                      : 'Type'
                  }
                  multiple
                  search
                  selection
                  options={typeOptions}
                  onClick={this.onDropdownClick}
                  onChange={this.onDropdownChange}
                  disabled={disableSearchingField}
                  style={{ marginLeft: '1em' }}
                  value={searchParams.type ? searchParams.type : []}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                {!editing && (
                  <Button
                    onClick={this.onFilterPanelOpen}
                    style={{ marginLeft: '1em' }}
                    active={mode === modes.ASSET_GALLERY.SEARCHING}
                  >
                    More Filters
                  </Button>
                )}

                {!editing && (
                  <Button
                    onClick={this.onClearFilterButtonClick}
                    disabled={
                      mode === modes.ASSET_GALLERY.UPLOAD_PENDING ||
                      mode === modes.ASSET_GALLERY.UPLOADING
                    }
                  >
                    Clear Filter
                  </Button>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        <Container fluid>
          <Grid padded column={'equal'}>
            <Grid.Row>
              <Grid.Column>
                {!editing && (
                  <Button
                    primary
                    onClick={this.onEditButtonClick}
                    disabled={disableSearchingField}
                  >
                    Edit/Delete Assets
                  </Button>
                )}

                {editing && (
                  <Button
                    onClick={this.onEditCancelButtonClick}
                    style={{ marginLeft: '1em' }}
                  >
                    Cancel
                  </Button>
                )}

                {editing && (
                  <Popup
                    trigger={
                      <Button primary disabled={!didAssetSelected}>
                        Edit
                      </Button>
                    }
                    onOpen={this.onEditPopupButtonClick}
                    onClose={this.onEditPopupClose}
                    position="top center"
                    open={openEditPopup}
                    on="click"
                  >
                    <AssetTagSelection
                      allowAdditions
                      ableToUpdateTags
                      tagOptions={tagOptions}
                      editing={editing}
                      selectedAssets={selectedAssets}
                      selectedTagOptions={selectedTagOptions}
                      updateTagOptions={updateTagOptions}
                      updateSelectedTagOptions={this.updateSelectedTagOptions}
                      updateAssetTags={this.updateAssetTags}
                      resetSelectTagOptions={this.resetSelectTagOptions}
                      style={{
                        width: '30em'
                      }}
                      user={user}
                    />
                  </Popup>
                )}

                {editing && (
                  <Button
                    negative
                    onClick={this.onDeleteButtonClick}
                    loading={deleting}
                    disabled={!didAssetSelected}
                  >
                    Delete
                  </Button>
                )}

                {error && error.type && (
                  <Label basic color="red" pointing="left">
                    {error.message}
                  </Label>
                )}

                <Button.Group>
                  <Button
                    onClick={this.onUploaderPanelOpen}
                    loading={mode === modes.ASSET_GALLERY.UPLOADING}
                    active={
                      mode === modes.ASSET_GALLERY.UPLOAD_PENDING ||
                      mode === modes.ASSET_GALLERY.UPLOADING
                    }
                    style={{
                      position: 'relative'
                    }}
                  >
                    {numberOfFilesInWorker > 0 &&
                      mode === modes.ASSET_GALLERY.NORMAL && (
                        <Label
                          basic
                          color="yellow"
                          pointing="below"
                          style={{
                            position: 'absolute',
                            top: '-135%',
                            width: '10em',
                            left: '0%'
                          }}
                        >
                          {`${numberOfFilesInWorker} file(s) are still in progress.`}
                        </Label>
                      )}
                    Upload New
                  </Button>
                  <Button
                    onClick={this.onDeselectButtonClick}
                    disabled={
                      mode === modes.ASSET_GALLERY.UPLOAD_PENDING ||
                      mode === modes.ASSET_GALLERY.UPLOADING
                    }
                  >
                    Deselect Asset
                  </Button>
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
}

AssetGalleryNav.defaultProps = {
  didAssetSelected: false
};

AssetGalleryNav.propTypes = {
  toggleFilterPanel: PropTypes.func.isRequired,
  toggleUploaderPanel: PropTypes.func.isRequired,
  updateGalleryMode: PropTypes.func.isRequired,
  updateSelectedAssets: PropTypes.func.isRequired,
  updateAssetTags: PropTypes.func.isRequired,
  deleteSelectedAssets: PropTypes.func.isRequired,
  searchAssets: PropTypes.func.isRequired,
  updateTagOptions: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  clearSearch: PropTypes.func.isRequired,
  didAssetSelected: PropTypes.bool,
  isFilterPanelOpened: PropTypes.bool.isRequired,
  isUploaderPanelOpened: PropTypes.bool.isRequired
};

export default AssetGalleryNav;



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/AssetGalleryNav.jsx